import React from 'react';
import { View } from 'react-native';
import { Text, useTheme } from '@ui-kitten/components';

import { RectangleLoader } from '../../Components/Loader';
import themeStyle from '../../Theme/styles';

import { TicketCurved, dashCount, styles } from './Ticket';
import { numberToArray } from '../../Helper';

const InfoLoader = ({
  labelWidth,
  valueWidth,
  noMargin,
}: {
  labelWidth?: string | number;
  valueWidth?: string | number;
  noMargin?: boolean;
}) => (
  <View style={[themeStyle.flex1, !noMargin && themeStyle.spacingBottomMedium]}>
    <View style={themeStyle.spacingBottomXSmall}>
      <RectangleLoader width={labelWidth || '100%'} height={20} />
    </View>
    <RectangleLoader width={valueWidth || '100%'} height={20} />
  </View>
);

const TicketLoader = ({
  contentContainerStyle,
  withShadow,
}: {
  contentContainerStyle?: any;
  withShadow?: boolean;
}) => {
  const theme = useTheme();
  return (
    <View style={[styles.ticketContainer, contentContainerStyle]}>
      {/* Ticket Content */}
      <View
        style={[
          styles.ticketContent,
          withShadow && { ...styles.shadow, ...styles.shadowTop },
        ]}
      >
        <RectangleLoader width="100%" height={218} />
        <View
          style={[
            themeStyle.pageVerticalSpacing,
            themeStyle.pageHorizontalSpacing,
          ]}
        >
          <View style={[themeStyle.flex1, themeStyle.spacingBottomMedium]}>
            <View
              style={[
                themeStyle.flex1,
                themeStyle.flexDirectionRowCenter,
                themeStyle.spacingBottomXSmall,
              ]}
            >
              <RectangleLoader width="100%" height={38} />
            </View>
            <RectangleLoader width="100%" height={22} />
          </View>
          <InfoLoader labelWidth={150} valueWidth={200} />
          <InfoLoader labelWidth={100} />
          <InfoLoader labelWidth={50} valueWidth={150} />
          <View style={themeStyle.flexDirectionRow}>
            <InfoLoader labelWidth={50} noMargin />
            <View style={themeStyle.rowSeparator} />
            <InfoLoader valueWidth={100} noMargin />
          </View>
        </View>
      </View>
      {/* Curved and dashed line */}
      <View style={styles.ticketCutOffPart}>
        <TicketCurved withBorder={withShadow} />
        <View style={styles.ticketDashContainer}>
          {numberToArray(dashCount).map((_, i) => (
            <View
              key={i}
              style={[
                themeStyle.flex1,
                themeStyle.pageHorizontalSpacingSmall,
                themeStyle.flexDirectionRowCenterCenter,
              ]}
            >
              <View
                style={[
                  styles.ticketDashed,
                  { backgroundColor: theme['text-basic-color'] },
                ]}
              />
            </View>
          ))}
        </View>
        <TicketCurved withBorder={withShadow} isRight />
      </View>
      {/* QR Code Container */}
      <View
        style={[
          styles.ticketQr,
          withShadow && { ...styles.shadow, ...styles.shadowBottom },
        ]}
      >
        <RectangleLoader width={200} height={200} />
        <View style={themeStyle.spacingTopMedium}>
          <RectangleLoader width={210} height={14} />
        </View>
      </View>
    </View>
  );
};

export default TicketLoader;
